import initialized from './initialized';

export default initialized;
